import createReactComponent from '../createReactComponent';
export default createReactComponent('one', 'One', [["path",{"d":"M12.438 17V7L9 9.5","key":"svg-0"}]]);